export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/format/number.js
// module id = 70
// module chunks = 3